import { styled } from "@linaria/react";

const Tick = styled.div`
  width: 1.3em;
  height: 1.3em;
  vertical-align: middle;
  flex: none;

  ::after {
    content: "";
    display: block;
    position: relative;
    left: 0.4em;
    width: 0.4em;
    height: 1em;
    border: 1px solid #1089ff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export default Tick;
